export default "__VITE_PUBLIC_ASSET__84b80247__"